import {
    Tooltip,
    Modal,
    Tab
} from 'bootstrap';
import {
    Chart,
    registerables
} from 'chart.js';
import 'chartjs-plugin-dragdata';
import html2canvas from 'html2canvas';
import {
    Notyf
} from 'notyf';
import Masonry from 'masonry-layout';
import axios from 'axios';
import Swal from 'sweetalert2';

const AOS = require("aos");

Chart.register(
    ... registerables
);

document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(function(tooltipTriggerEl) {
    return new Tooltip(tooltipTriggerEl)
});

// Remove background-img border
document.querySelectorAll('img:not([src])').forEach((element) => {
    element.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
});

let masonry;
const tabEl = document.querySelector('[data-bs-target="#information-tab-pane"]')
tabEl.addEventListener('shown.bs.tab', event => {
    if(masonry) {
        masonry.destroy();
    }

    setTimeout(() => {
        masonry = new Masonry('.domain-card-container', {
            itemSelector: '.domain-card'
        });
    }, 50);

    document.querySelector('.save-pdf').style.opacity       = 0;
    document.querySelector('.save-pdf').style.pointerEvents = 'none';
})

const resizeTextAreas = () => {
    document.querySelectorAll('textarea').forEach((el) => {
        el.setAttribute('style', 'height:' + (el.scrollHeight) + 'px;overflow-y:hidden;');
        el.addEventListener("input", (event) => {
            event.currentTarget.style.height = 0;
            event.currentTarget.style.height = (event.currentTarget.scrollHeight) + "px";
        });
    });

    document.querySelector('.save-pdf').removeAttribute('style');
}

document.querySelector('[data-bs-target="#agreements-tab-pane"]').addEventListener('shown.bs.tab', resizeTextAreas);
document.querySelector('[data-bs-target="#home-tab-pane"]').addEventListener('shown.bs.tab', (event) => {
    document.querySelector('.save-pdf').removeAttribute('style');
});

// Init Animate On Scroll
AOS.init();

// Smooth scroll
if(document.querySelector('.js-scroll-trigger')) {
    document.querySelectorAll('.js-scroll-trigger').forEach(link => {
        link.addEventListener('click', event => {
            event.preventDefault();
            const href      = event.currentTarget.getAttribute("href");
            const offsetTop = document.querySelector(href).offsetTop;

            scroll({
                top:      offsetTop,
                behavior: "smooth"
            });
        });
    });
}

/*document.querySelector('.btn-next').addEventListener('click', (event) => {
    event.preventDefault();

    selectNext(true);
});

document.querySelector('.btn-previous').addEventListener('click', (event) => {
    event.preventDefault();

    selectPrevious(true);
});
 */

const context = document.getElementById('radarChart').getContext('2d');

const labels = [
    'Leervaardigheid',
    'Eten en drinken',
    'Continentie',
    'Lichaamshouding',
    'Mobiliteit',
    'Dag- en nachtritme',
    'Aan- en uitkleden',
    'Lichaamstemperatuur',
    'Hygiëne',
    'Veiligheid',
    'Communicatie',
    'Contact met anderen',
    'Normbesef',
    'Dagelijkse activiteiten',
    'Recreatie, sport en spel'
];

[... document.querySelectorAll('.sidebar .menu-links input[type="number"]')].map((el, i) => {
    [... document.querySelectorAll('.domain-agreements input[type="number"]')][i].value = el.value;
});

const data = {
    labels:   labels,
    datasets: [{
        labels:               labels,
        tension:              0,
        data:                 [... document.querySelectorAll('.sidebar .menu-links input[type="number"]')].map(el => parseInt(el.value)),
        pointHitRadius:       25,
        pointBackgroundColor: window.colours,
        borderColor:          '#000000',
        backgroundColor:      'rgba(0,0,0,0.0)',
        borderWidth:          3
    }]
};

const chart = new Chart(context, {
    type:       'radar',
    data:       data,
    responsive: true,
    options:    {
        scales:  {
            r: {
                min:         0,
                max:         9,
                ticks:       {
                    stepSize: 1,
                    display:  false
                },
                pointLabels: {
                    display: false
                },
                angleLines:  {
                    display: false
                },
                grid:        {
                    display: false
                }
            }
        },
        plugins: {
            legend:   {
                display: false
            },
            dragData: {
                round:  0,
                onDrag: (e, datasetIndex, index, value) => {
                    if(value === 0 || value > 5) return false;

                    const elements = [... document.querySelectorAll('.sidebar .menu-links input[type="number"]')];
                    if(elements[index]) {
                        elements[index].value = value;
                        select(elements[index]);
                    }

                    const domainAgreements = [... document.querySelectorAll('.domain-agreements input[type="number"]')];
                    if(domainAgreements[index]) {
                        domainAgreements[index].value = value;
                    }

                },
            }
        }
    }
});

document.getElementById('radarChart').addEventListener('click', (event) => {
    const activePoints = chart.getElementsAtEventForMode(event, 'point', {
        axis: 'r'
    }, false)[0];

    let x, y, v;

    x = event.clientX - chart.canvas.getBoundingClientRect().left;
    y = event.clientY - chart.canvas.getBoundingClientRect().top;

    const rScale = chart.scales.r;
    const xTry   = event.clientX - chart.canvas.getBoundingClientRect().left - rScale.xCenter;
    const yTry   = event.clientY - chart.canvas.getBoundingClientRect().top - rScale.yCenter;

    const radians = Math.atan2(yTry, xTry);
    let degrees   = radians * 180 / Math.PI;
    degrees       = degrees > 0 ? degrees : degrees + 360;
    degrees       = degrees > 258 ? degrees - 360 : degrees;

    let d     = Math.sqrt(Math.pow(x - rScale.xCenter, 2) + Math.pow(y - rScale.yCenter, 2));
    let value = Math.round(rScale.getValueForDistanceFromCenter(d));

    let closest    = Number.POSITIVE_INFINITY;
    let closestKey = Number.POSITIVE_INFINITY;
    for(let i = 0; i < rScale.getLabels().length; i++) {
        let offset         = rScale.getDistanceFromCenterForValue(5);
        let position       = rScale.getPointPosition(i, offset);
        let degreesOfLabel = position.angle * 180 / Math.PI;

        let possibleClosest = Math.abs(degreesOfLabel - degrees);
        if(possibleClosest < closest) {
            closest    = possibleClosest;
            closestKey = i;
        }
    }

    const el                = [... document.querySelectorAll('.sidebar .menu-links input[type="number"]')][closestKey]
    const domainAgreementEl = [... document.querySelectorAll('.domain-agreements input[type="number"]')][closestKey];

    if(value > 5) {
        select(el);
        const modal = Modal.getOrCreateInstance(document.getElementById('modal'));
        modal.show();
        return;
    }

    value = value < 1 ? 1 : value;
    value = value > 5 ? 5 : value;

    el.value                = value;
    domainAgreementEl.value = value;
    select(el);
    chart.data.datasets[0].data[closestKey] = value;
    chart.update();
});


const body       = document.querySelector("body"),
      sidebar    = body.querySelector("nav:not(.show-small)"),
      modeSwitch = body.querySelector(".toggle-switch"),
      modeText   = body.querySelector(".mode-text"),
      nameField  = body.querySelector('[name="name"]'),
      savePdf    = body.querySelector('.save-pdf');

savePdf.addEventListener('click', async(event) => {
    if(!event.currentTarget.classList.contains('loading')) {
        const buttonElement = event.currentTarget;

        // Check if domain agreements are completely empty.
        let confirmed = true;
        if([... document.querySelectorAll('.domain-card-explanation-container .domain-card-body textarea')].filter(el => el.value.trim() !== '').length === 0) {
            const swalConfirmed = await Swal.fire({
                title:             'Let op!',
                text:              'Wil je de PDF downloaden zonder afspraken vast te leggen?',
                showDenyButton:    true,
                confirmButtonText: 'Ja, downloaden',
                denyButtonText:    'Eerst afspraken vastleggen',
            });

            confirmed = swalConfirmed.isConfirmed;

            if(confirmed === false) {
                document.getElementById('agreements-tab').click();
            }
        }

        if(confirmed === true) {

            buttonElement.classList.add('loading');

            buttonElement.querySelector('i').classList.remove('bxs-file-pdf');
            buttonElement.querySelector('i').classList.add('bx-loader-alt', 'bx-spin');
            document.querySelector('.loading-mask').style.opacity = 1;

            document.getElementById('home-tab').click();

            const formData = new FormData();
            formData.append('name', nameField.value);

            [... document.querySelectorAll('ul.menu-links .nav-link input[type="number"]')].map((el) => {
                formData.append('domainScores[]', el.value);
            });

            [... document.querySelectorAll('.domain-card-explanation-container .domain-card-body textarea')].map((el) => {
                formData.append('domainAgreements[]', el.value);
            });

            [... document.querySelectorAll('.domain-completed')].map((el) => {
                formData.append('domainCompleted[]', el.checked);
            });

            document.querySelector('.chart-background').style.height = '1920px';
            document.querySelector('.chart-background').style.width  = '1920px';

            setTimeout(async() => {
                const canvas = await html2canvas(document.querySelector('.chart-background'), {
                    logging:         false,
                    backgroundColor: null
                });

                document.querySelector('.loading-mask').style.opacity = 0;

                document.querySelector('.chart-background').removeAttribute('style')

                const imageData = canvas.toDataURL('image/png');
                formData.append('chartImage', imageData);

                axios.post('/api/generate-pdf', formData, {
                    responseType: 'arraybuffer'
                }).then((response) => {
                    const blob = new Blob([response.data], { type: 'application/pdf' });

                    const personalized = nameField.value.toString()
                        .normalize('NFD')
                        .replace(/[\u0300-\u036f]/g, '')
                        .toLowerCase()
                        .trim()
                        .replace(/\s+/g, '-')
                        .replace(/[^\w-]+/g, '')
                        .replace(/--+/g, '-');

                    const downloadTag    = document.createElement('a');
                    downloadTag.href     = URL.createObjectURL(blob);
                    downloadTag.download = (personalized !== '' ? personalized : 'jouw-resultaten') + '-zelfredzaamheidsradar.pdf';
                    downloadTag.click();
                    downloadTag.remove();
                }).finally(() => {
                    buttonElement.querySelector('i').classList.remove('bx-loader-alt', 'bx-spin');
                    buttonElement.querySelector('i').classList.add('bxs-file-pdf');

                    buttonElement.classList.remove('loading');
                });
            }, 100);
        }
    }
})

let blackAndWhiteSvg = null;
let colourSvg        = null;
modeSwitch.addEventListener("click", () => {

    body.classList.toggle("dark");
    if(body.classList.contains("dark")) {
        modeText.innerText = "Kleur versie";

        if(blackAndWhiteSvg === null) {
            fetch('/img/radar-zw.svg').then(response => response.text()).then((data) => {
                document.querySelector('.chart-background > .svg').innerHTML = data;

                blackAndWhiteSvg = data;
            });
        } else {
            document.querySelector('.chart-background > .svg').innerHTML = blackAndWhiteSvg;
        }

        if(document.querySelector('.steps-svg')) {
            document.querySelector('.steps-svg').src = '/img/steps-grey.svg';

        }

        chart.data.datasets[0].pointBackgroundColor = window.coloursBlackAndWhite;
        chart.update();
    } else {
        modeText.innerText = "Zwart-wit versie";

        if(colourSvg === null) {
            fetch('/img/radar.svg').then(response => response.text()).then((data) => {
                document.querySelector('.chart-background > .svg').innerHTML = data;

                colourSvg = data;
            });
        } else {
            document.querySelector('.chart-background > .svg').innerHTML = colourSvg;
        }

        if(document.querySelector('.steps-svg')) {
            document.querySelector('.steps-svg').src = '/img/steps.svg';
        }

        chart.data.datasets[0].pointBackgroundColor = window.colours;
        chart.update();
    }
});

const checkNameField = (element) => {
    document.querySelector('h3.name').innerText = element.value;
}

checkNameField(nameField);

nameField.addEventListener('keyup', (e) => {
    checkNameField(e.currentTarget);
});

const shadeColor = (color, percent) => {

    var R = parseInt(color.substring(1, 3), 16);
    var G = parseInt(color.substring(3, 5), 16);
    var B = parseInt(color.substring(5, 7), 16);

    R = parseInt(R * (100 + percent) / 100);
    G = parseInt(G * (100 + percent) / 100);
    B = parseInt(B * (100 + percent) / 100);

    R = (R < 255) ? R : 255;
    G = (G < 255) ? G : 255;
    B = (B < 255) ? B : 255;

    var RR = ((R.toString(16).length == 1) ? "0" + R.toString(16) : R.toString(16));
    var GG = ((G.toString(16).length == 1) ? "0" + G.toString(16) : G.toString(16));
    var BB = ((B.toString(16).length == 1) ? "0" + B.toString(16) : B.toString(16));

    return "#" + RR + GG + BB;
}

document.querySelectorAll('.sidebar .menu-links li').forEach((el) => {
    el.addEventListener('click', (event) => {
        if(event.currentTarget.querySelector('input[type="number"]')) {
            event.currentTarget.querySelector('input[type="number"]').focus();
            event.currentTarget.querySelector('input[type="number"]').select();

            document.querySelectorAll('li.nav-link').forEach(el => el.classList.remove('focus-within'));

            event.currentTarget.classList.add('focus-within');

            checkExplanation();
        }
    });
});

document.querySelectorAll('.sidebar .menu-links li input[type="number"]').forEach((el) => {
    el.addEventListener('keyup', (event) => {
        if(event.key >= 1 && event.key <= 5) {
            event.currentTarget.value = event.key;
        }

        const currentValue = event.currentTarget.value;

        if(currentValue > 5) {
            event.currentTarget.value = 5;
        }

        if(currentValue < 1) {
            event.currentTarget.value = 1;
        }

        const elements         = [... document.querySelectorAll('.sidebar .menu-links input[type="number"]')];
        const domainAgreements = [... document.querySelectorAll('.domain-agreements input[type="number"]')];
        const indexOf          = elements.indexOf(el);

        domainAgreements[indexOf].value = currentValue;

        chart.data.datasets[0].data[indexOf] = event.currentTarget.value;
        chart.update();

        selectNext();
    });
});

//const notification                 = new Notyf();
let currentExplanationNotification = null;

const checkExplanation = () => {
    if(document.querySelector('li.nav-link.focus-within')) {
        const selected = document.querySelector('li.nav-link.focus-within');
        if(selected.dataset.tip !== '') {

            /*
            if(typeof (currentExplanationNotification) !== 'undefined' && currentExplanationNotification !== null && currentExplanationNotification.options.message === 'Meer informatie over ' + selected.dataset.title.toLowerCase()) {
                return;
            }

            if(typeof (currentExplanationNotification) !== 'undefined') {
                notification.dismiss(currentExplanationNotification);
            }
             */

            const colour = body.classList.contains('dark') ? selected.dataset.colourBlackAndWhite : selected.dataset.colour;
            /*currentExplanationNotification = notification.open({
                message:    'Meer informatie over ' + selected.dataset.title.toLowerCase(),
                duration:   0,
                background: 'linear-gradient(to right, ' + colour + ', ' + shadeColor(colour, -40) + ')',
                icon:       {
                    className: 'bx bx-info-circle',
                    tagName:   'i'
                }
            });

            currentExplanationNotification.on('click', ({
                                                            target,
                                                            event
                                                        }) => {
                event.preventDefault();
                const modal = Modal.getOrCreateInstance(document.getElementById('modal'));
                modal.show();
            });*/

            document.getElementById('modal').querySelector('h3.modal-title').innerHTML = selected.dataset.title;
            document.getElementById('modal').querySelector('.modal-header').style.setProperty('--primary-color', colour);
            document.getElementById('modal').querySelector('.modal-body > div').innerHTML = selected.dataset.tip;
        }
    }
}
checkExplanation();

const select = (el) => {
    if(el) {
        if(window.clientWidth > 1280) {
            el.focus();
            el.select();
        }

        document.querySelectorAll('li.nav-link').forEach(el => el.classList.remove('focus-within'));
        el.parentNode.parentNode.classList.add('focus-within');

        checkExplanation();
    }
}

const selectNext = (loopAround = false) => {
    const currentElement = document.querySelector('.focus-within input');

    const elements = [... document.querySelectorAll('.sidebar .menu-links input[type="number"]')];
    const indexOf  = elements.indexOf(currentElement);

    let element = null;
    if(elements[indexOf + 1]) {
        element = elements[indexOf + 1];
    } else if(loopAround === true) {
        element = elements[0];
    }

    if(element !== null) {
        element.focus();
        element.select();

        document.querySelectorAll('li.nav-link').forEach(el => el.classList.remove('focus-within'));
        element.parentNode.parentNode.classList.add('focus-within');

        checkExplanation();
    }
}

const selectPrevious = (loopAround = false) => {
    const currentElement = document.querySelector('.focus-within input');

    const elements = [... document.querySelectorAll('.sidebar .menu-links input[type="number"]')];
    const indexOf  = elements.indexOf(currentElement);

    let element = null;
    if(elements[indexOf - 1]) {
        element = elements[indexOf - 1];
    } else if(loopAround === true) {
        element = elements[elements.length - 1];
    }

    if(element !== null) {
        element.focus();
        element.select();

        document.querySelectorAll('li.nav-link').forEach(el => el.classList.remove('focus-within'));
        element.parentNode.parentNode.classList.add('focus-within');

        checkExplanation();
    }
}